import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slideoverLink"]

  open(event) {
    // Don't open if clicking a link, button, or form inside the row
    if (event.target.closest("a, button, form")) return

    if (this.hasSlideoverLinkTarget) {
      this.slideoverLinkTarget.click()
    }
  }
}
